import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 4l-3 3h2v13h2V7h2l-3-3zm-6.2 11.5v-5l2.2-.9V7.5L3 12.25v1.5l11 4.75v-2.1l-2.2-.9zM4.98 13L10 11.13v3.74L4.98 13z"
}), 'TextRotateUpTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TextRotateUpTwoTone.js
// module id = 6723
// module chunks = 2